require('./site/bootstrap')
require('dragscroll')

import Masonry from 'masonry-layout'
import SwiperCore, { Pagination, Autoplay, Lazy, EffectFade } from 'swiper/core'

SwiperCore.use([Pagination, Autoplay, Lazy, EffectFade])

import 'bootstrap/js/dist/dropdown';

$(function () {
	const rootEl = $('html')
	const scrollEl = $('html,body')
	const appEl = $('#app')

	/*/
	 *  Video
	/*/
		const siteVideo = document.querySelectorAll('[mq-video]')

		if (siteVideo) {
			siteVideo.forEach(e => {
				e.addEventListener('click', c => {
					c.preventDefault()

					const container = e.parentElement
					const iframe = `<iframe class="mr--full" src="${e.dataset.embed}?autoplay=1&rel=0&controls=1&showinfo=0&muted=1" width="560" height="315" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
					const delay = (parseFloat(window.getComputedStyle(e).transitionDuration) * 1000) + 100

					container.classList.add('is--invisible')

					setTimeout(_ => {
						container.innerHTML = iframe
					}, delay);
				})
			})
		}


	/*/
	 *  Projects nav
	/*/
		const compacter = function () {
			let navwidth = 0
			let morewidth = $('[mq-more] .nav--more').outerWidth(true)

			$('[mq-more] > li:not(.nav--more)').each(function () {
				navwidth += $(this).outerWidth(true)
			})

			let availablespace = $('[mq-more]').parent().width() - morewidth;

			if (navwidth > availablespace) {
				let lastItem = $('[mq-more] > li:not(.nav--more)').last()
				lastItem.attr('data-width', lastItem.outerWidth(true))
				lastItem.prependTo($('[mq-more] .nav--more > ul'))
				compacter();
			} else {
				let firstMoreElement = $('[mq-more] li.nav--more > ul > li').first()
				if (navwidth + firstMoreElement.data('width') < availablespace) {
					firstMoreElement.insertBefore($('[mq-more] .nav--more'))
				}
			}

			if ($('[mq-more] .nav--more > ul > li').length > 0) {
				$('[mq-more] .nav--more').removeClass('d-none')
				$('[mq-more]').addClass('justify-content-md-between').removeClass('justify-content-md-start')
			} else {
				$('[mq-more] .nav--more').addClass('d-none')
				$('[mq-more]').addClass('justify-content-md-start').removeClass('justify-content-md-between')
			}

			let innerActive = $('[mq-more] .nav--more .is--active').length == 1 ? true : false
			let innerActiveClass = $('[mq-more] .nav--more')

			if (innerActive) {
				innerActiveClass.addClass('is--active')
			} else {
				innerActiveClass.removeClass('is--active')
			}
		}

		$(window).on('resize', function () {
			setTimeout(function () {
				compacter()
			}, 100)
		})

		$(window).on('load', function () {
			setTimeout(function () {
				compacter()
			}, 100)
		})

		compacter()


	/*/
	 *  Masonry
	/*/
		const hasGrid = document.querySelector('.projects--grid_content')

		if (hasGrid) {
			const msnry = new Masonry('.projects--grid_content', {
				columnWidth: '.projects--grid_size',
				itemSelector: '.projects--grid_item',
			})

			$('.projects--grid_content img').on('load', () => msnry.layout())
		}


	/*/
	 *  Nav
	/*/
		$('[mq-nav]').on('click', () => {
			rootEl.toggleClass('is--nav')
		})

		$(document).on('keyup', function(e) {
			if (rootEl.hasClass('is--nav') && e.keyCode == 27) {
				rootEl.removeClass('is--nav')
			}
		}).on('click', () => {
			rootEl.removeClass('is--nav')
		})

		$('.header--nav').click(function (event) {
			event.stopPropagation()
		})

		$('.header--toggle').click(function (event) {
			event.stopPropagation()
		})

		if (!!window.IntersectionObserver) {
			let headerEl = document.querySelector('.header')
			let observerHeader = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						rootEl.removeClass('is--nav')
					}
				})
			}, {
				threshold: 0
			})

			observerHeader.observe(headerEl)
		}


	/*/
		*  Swiper
	/*/
		const swiperBanner = new SwiperCore('[mq-banner]', {
			loop: true,
			speed: 1000,
			slidesPerView: 1,
			autoHeight: false,
			observer: true,
			watchOverflow: true,
			threshold: 5,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			lazy: {
				loadPrevNext: true
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: true
			},
			pagination: {
				el: '.swiper-pager',
				clickable: true,
				lockClass: 'd-none',
				currentClass: 'active'
			}
		})


	/*/
	 *  Anchor
	/*/
		// $('[sd-anchor]').click(a => {
		// 	a.preventDefault()

		// 	scrollEl.animate({
		// 		scrollTop: appEl.offset().top
		// 	}, 1000);
		// })


	/*/
	 *  Fancybox
	/*/
		// $().fancybox({
		// 	selector : '[sd-fancybox]',
		// 	loop: true,
		// 	buttons: ['zoom', 'fullScreen', 'close'],
		// 	protect: true,
		// 	infobar: false,
		// 	arrows: true,
		// 	animationEffect: 'fade'
		// })


	/*/
	 *  Scroll reveal
	/*/
		// setTimeout(() => {
			const ScrollReveal = require('scrollreveal')({
				scale: 1,
				duration: 750,
				reset: false,
				mobile: true,
				viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
			})
	
			ScrollReveal.reveal('.sr', {
				origin: 'bottom',
				distance: false
			})
	
			ScrollReveal.reveal('.sr--bottom', {
				distance: '75px',
				origin: 'bottom'
			})
		// }, 750);


	/*/
	 *  Input file
	/*/
		// $('input[type="file"]').change(function() {
		// 	let fileName = $(this).parent().find('.form-control')
		// 	let filePlaceholder = $(this).parent().data('placeholder')

		// 	if (!this.files.length) {
		// 		fileName.html(`<span class="placeholder">${filePlaceholder}</span>`)
		// 	} else if (this.files.length === 1 ) {
		// 		fileName.html(`${this.files[ 0 ].name}`)
		// 	} else {
		// 		fileName.html(`${this.files.length} arquivos selecionados`)
		// 	}
		// })
})

/*/
 * Alert
/*/
	window.siteAlert = function (params) {
		params = {
			text: params.text ? params.text : '',
			class: params.class ? params.class : 'alert--success',
			seconds: params.seconds ? params.seconds : 6000,
		}

		const alert = document.querySelector('[mq-alert]')

		alert.classList.remove('alert--success')
		alert.classList.remove('alert--error')
		alert.classList.add(params.class)
		alert.innerHTML = params.text

		setTimeout(function () { alert.classList.add('is--visible') }, 500)
		setTimeout(function () { alert.classList.remove('is--visible') }, params.seconds)

		alert.addEventListener('click', function () {
			this.classList.remove('is--visible')
		})
	}


/*/
 * Form validation
/*/
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('.needs-validation')
		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const formReturnSuccess = form.dataset.success
				const formReturnError = form.dataset.error

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					this.querySelector(':invalid').focus()
				} else {
					event.preventDefault()

					button.innerText = 'Enviando...'
					button.disabled = true

					const data = new FormData(this)
					const options = {
						headers: { 'Content-Type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
					.then(_ => {
						form.reset()
						form.classList.remove('was-validated')

						siteAlert({
							text: formReturnSuccess,
							class: 'alert--success',
							seconds: 12000
						})
					}).catch(err => {
						console.error(err)

						siteAlert({
							text: formReturnError,
							class: 'alert--error',
							seconds: 6000
						})
					}).finally(_ => {
						setTimeout(() => {
							button.innerText = 'Enviar'
							button.disabled = false
						}, 2000)
					})
				}

				form.classList.add('was-validated')
			}, false)
		})
	})
